export default class Company {
    constructor() {
        this.id;
        this.name;
        this.bankName;
        this.bankBranchCode;
        this.bankAccountNumber;
        this.bankAccountType;
        this.applicationFormFileId;
        this.letterOfGoodStandingFileId;
        this.registrationNumber;
        this.vatNumber;
        this.address1;
        this.address2;
        this.address3;
        this.address4;
        this.postalAddress;
        this.customerCompanyContacts;
        this.companyStatus = 1;
        this.brokerId;
        this.companyNotes = [];
        this.accountNumber;
        this.paymentPreference = 1;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.name = setEntity.name;
        this.bankName = setEntity.bankName;
        this.bankBranchCode = setEntity.bankBranchCode;
        this.bankAccountNumber = setEntity.bankAccountNumber;
        this.bankAccountType = setEntity.bankAccountType;
        this.applicationFormFileId = setEntity.applicationFormFileId;
        this.letterOfGoodStandingFileId = setEntity.letterOfGoodStandingFileId;
        this.registrationNumber = setEntity.registrationNumber;
        this.vatNumber = setEntity.vatNumber;
        this.address1 = setEntity.address1;
        this.address2 = setEntity.address2;
        this.address3 = setEntity.address3;
        this.address4 = setEntity.address4;
        this.postalAddress = setEntity.postalAddress;
        this.companyStatus = setEntity.companyStatus;
        this.customerCompanyContacts = setEntity.customerCompanyContacts ? setEntity.customerCompanyContacts : [];
        this.brokerId = setEntity.brokerId;
        this.companyNotes = setEntity.companyNotes ? setEntity.companyNotes : [];
        this.accountNumber = setEntity.accountNumber;
        this.paymentPreference = setEntity.paymentPreference;
        return this;
    }
}
